import PropTypes from "prop-types";
// @mui
import { Stack, InputAdornment, TextField, Button } from "@mui/material";
// components
import Iconify from "../../../../components/iconify";
import { MobileDateTimePicker } from "@mui/x-date-pickers";

const INPUT_WIDTH = 200;

CustomerOrderTableToolbar.propTypes = {
  isFiltered: PropTypes.bool,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  onResetFilter: PropTypes.func,
  onFilterType: PropTypes.func,
  onFilterEndDate: PropTypes.func,
  onFilterStartDate: PropTypes.func,
  filterEndDate: PropTypes.instanceOf(Date),
  filterStartDate: PropTypes.instanceOf(Date),
};
export default function CustomerOrderTableToolbar({
  isFiltered,
  filterName,
  onFilterName,
  onResetFilter,
  filterStartDate,
  filterEndDate,
  onFilterEndDate,
  onFilterStartDate,
}) {
  const padString = (str, length) => {
    return str.padEnd(length, "");
  };

  const formatData = (data) => {
    if (!data || data.length === 0) return data;

    const fields = Object.keys(data[0]);
    const maxLengths = fields.map((field) => {
      return Math.max(...data.map((row) => String(row[field]).length));
    });

    return data.map((row) => {
      const formattedRow = {};
      fields.forEach((field, index) => {
        formattedRow[field] = padString(String(row[field]), maxLengths[index]);
      });
      return formattedRow;
    });
  };

  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{
        xs: "column",
        sm: "row",
      }}
      sx={{ px: 2.5, py: 3 }}
    >
      <MobileDateTimePicker
        label="Start date"
        value={filterStartDate}
        onChange={onFilterStartDate}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            sx={{
              maxWidth: { md: INPUT_WIDTH },
            }}
          />
        )}
      />

      <MobileDateTimePicker
        label="End date"
        value={filterEndDate}
        onChange={onFilterEndDate}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            sx={{
              maxWidth: { md: INPUT_WIDTH },
            }}
          />
        )}
      />

      <TextField
        fullWidth
        value={filterName}
        onChange={onFilterName}
        placeholder="Search..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: "text.disabled" }} />
            </InputAdornment>
          ),
        }}
      />

      {isFiltered && (
        <Button
          color="error"
          sx={{ flexShrink: 0 }}
          onClick={onResetFilter}
          startIcon={<Iconify icon="eva:trash-2-outline" />}
        >
          Clear
        </Button>
      )}
    </Stack>
  );
}
